exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/coldfusion-dev/coldfusion-dev.component.css
// module id = ../../../../../src/app/coldfusion-dev/coldfusion-dev.component.css
// module chunks = main